import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLS } from '../constants/constants';
import { HeaderType, MediaCategory } from '../enums/enums';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private http: HttpService) {}

  getMediaSignedUrl(payload: {
    fileName: string;
    contentType: string;
    category: MediaCategory;
  }): Observable<{ contentUrl: string; key: string; uploadUrl: string }> {
    return this.http.post(`${URLS.mediaSignedUrl}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  uploadFile(url: string, file: File) {
    return this.http.uploadPut(url, file);
  }
  uploadFileWithReportProgress(url: string, file: File) {
    return this.http.uploadPut(url, file, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
